<chart [ngClass]="{'placeholder': showPlaceholder}" [options]="options" (load)="saveInstance($event.context)"></chart>
<div *ngIf="titleTooltip" class="tooltip-title-wrapper">
  <achoo-icon-tooltip [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
</div>
<div class="message-popup" *ngIf="showPlaceholder && useDefaultPlaceholder">
  <div class="title">{{'common.missing_data.line_chart_title' | translate}}</div>
  <div>{{fallbackMsg}}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-line-chart/achoo-line-chart.component.html